import {
    SET_PATIENTS,
    SET_EMAIL_TEMPLATE,
    SET_PROMPT,
    SET_CUSTOM_EMAIL_TEMPLATE,
    SET_PATIENT_INVITE_LOGS,
} from "./types";
import { apiCallV2, servicesAPICall } from "../../../utils/api";
import { removeDuplicates } from "../../../utils";

export const GetPatientInviteLogs = (page = 1, count = 5, filter = null, sort = null) => async (dispatch) => {

    const res = await apiCallV2(
        "GET",
        "admin/get-patient-invite-log",
        "",
        localStorage.getItem("access-token"),
        {
            page: page,
            limit: count,
            filters: filter,
            sort: sort,
        },
    );

    if (res?.status === 200) {

        const list = res?.data?.patientInviteLogs?.map((log) => {
            return {
                ...log,
                subscriptions: log?.subscriptions ? removeDuplicates(JSON.parse(log?.subscriptions), ["id"])?.sort((a, b) => b.id - a.id) : [],
            }
        });

        dispatch({
            type: SET_PATIENT_INVITE_LOGS,
            data: {
                list: list,
                count: res?.data?.count[0]["count(*)"],
            }
        })

    }

}

export const GetDischargedPatients = (page = 1, count = 5, filter = null, sort = null) => async (dispatch) => {

    const res = await servicesAPICall(
        "GET",
        "clinicient/pt/get-indi-records",
        "",
        localStorage.getItem("access-token"),
        {
            page: page,
            limit: count,
            filters: filter,
            sort: sort,
        },
    );

    if (res?.status === 200) {

        const list = res?.data?.brgDischargedPatients?.map((patient) => {
            return {
                ...patient,
                emailSentLogs: patient?.sentEmailLogs ? removeDuplicates(JSON.parse(patient?.sentEmailLogs), ["id"]) : [],
                generatedEmails: patient?.emailsGenerated ? JSON.parse(patient?.emailsGenerated) : [],
            }
        })

        dispatch({
            type: SET_PATIENTS,
            data: {
                list: res?.data?.brgDischargedPatients ? list : [],
                count: res?.data?.count[0]["count(*)"],
            }
        })

    }

}

export const GetEmailTemplates = (page, count, filter, sort, isReturn = false) => async (dispatch) => {
    const res = await apiCallV2(
        "GET",
        "email-template/pt/get",
        "",
        localStorage.getItem("access-token"),
        {
            page: page,
            limit: count,
            filters: filter,
            sort: sort,
        },
    );

    if (!isReturn) {
        dispatch({
            type: !filter?.owner ? SET_EMAIL_TEMPLATE : SET_CUSTOM_EMAIL_TEMPLATE,
            data: {
                list: res.data.emailTemplates,
                count: res.data.count[0]["count(*)"]
            }
        })
    } else {
        return res.data.emailTemplates;
    }


}

export const GetPrompt = (name, key = null) => async (dispatch) => {
    const res = await apiCallV2(
        "GET",
        "prompt/pt/get",
        "",
        localStorage.getItem("access-token"),
        {
            name: name,
        },
    );

    dispatch({
        type: SET_PROMPT,
        data: {
            prompt: res?.data?.data?.prompt[0],
            name: name,
            key: key,
        }
    })

}

export const GenerateEmail = (prompt, patient) => async (dispatch, getState) => {
    const { patients } = getState().PatientInvite;

    const res = await servicesAPICall(
        "GET",
        "clinicient/pt/generate-brg-patient-email",
        "",
        localStorage.getItem("access-token"),
        {
            prompt: prompt,
            patient: patient,
        },
    );


    if (res?.data?.data?.id > 0) {

        const newPatientList = patients?.list?.map((dp, i) => {
            return dp?.id == patient ? {
                ...dp,
                generatedEmails: [...dp?.generatedEmails, {
                    ...res.data.data,
                    filtered: 0,
                    tracking_id: null
                }]
            } : dp;
        })

        dispatch({
            type: SET_PATIENTS,
            data: {
                list: [...newPatientList],
                count: patients?.count
            }
        })

        // let temp = { ...generatedEmails };

        // if (temp[patient]?.length > 0) {
        //     temp[patient].unshift(res.data.data);
        // } else {
        //     temp[patient] = [res.data.data];
        // }

        // dispatch({
        //     type: SET_GENERATED_EMAIL,
        //     data: temp
        // })

        return {
            success: true,
            data: {
                ...res.data.data,
                filtered: 0,
                tracking_id: null
            },
        };
    } else {
        return {
            success: false,
        };
    }

}

export const FilterEmailContent = (prompt, patient, oldEmail) => async (dispatch, getState) => {
    const { patients } = getState().PatientInvite;

    const res = await servicesAPICall(
        "GET",
        "clinicient/pt/generate-filtered-email",
        "",
        localStorage.getItem("access-token"),
        {
            prompt: prompt,
            patient: patient,
            oldEmail: oldEmail?.id
        },
    );



    if (res?.data?.data?.id > 0) {

        const newPatientList = patients?.list?.map((dp, i) => {
            return dp?.id == patient ? {
                ...dp,
                generatedEmails: [...dp?.generatedEmails, {
                    ...res.data.data,
                    filtered: 1,
                    tracking_id: null
                }]
            } : dp;
        })


        dispatch({
            type: SET_PATIENTS,
            data: {
                list: [...newPatientList],
                count: patients?.count
            }
        })


        return {
            success: true,
            data: {
                ...res.data.data,
                filtered: 1,
                tracking_id: null
            },
        };
    } else {
        return {
            success: false,
        };
    }

}

export const AddNewCustomEmailTemplate = (et) => async (dispatch, getState) => {
    const res = await apiCallV2(
        "POST",
        "email-template/pt/custom/add",
        {
            name: et.name,
            content: et.html_content,
            emailSubject: et.email_subject,
            tag: et.tag,
        },
        localStorage.getItem("access-token"),
    );

    if (res?.data?.success) {
        const { list, count } = getState().PatientInvite?.customEmailTemplates;
        let temp = [...list];
        temp.unshift(res?.data?.data);

        dispatch({
            type: SET_CUSTOM_EMAIL_TEMPLATE,
            data: {
                list: temp,
                count: count + 1
            }
        })
        return {
            success: true,
            newET: {
                ...et,
                ...res?.data?.data,
            }
        };

    } else {
        return false;
    }

}

export const SaveEmailTemplate = (et) => async (dispatch, getState) => {

    const res = await apiCallV2(
        "POST",
        "email-template/pt/save",
        {
            ...et,
        },
        localStorage.getItem("access-token"),
    );


    if (res?.data?.data?.success) {
        const { list, count } = getState().PatientInvite?.customEmailTemplates;
        let temp = [...list];

        temp = temp.map((l, i) => {
            return et.id != l.id
                ? l
                : {
                    ...et
                }
        })

        dispatch({
            type: SET_CUSTOM_EMAIL_TEMPLATE,
            data: {
                list: temp,
                count: count
            }
        })

        return true;
    } else {
        return false;
    }

}

export const SendEmail = (patient, email, html, subject, eventID, emailTemplate, sender) => async (dispatch, getState) => {
    const { list, count } = getState().PatientInvite?.patients;

    const res = await servicesAPICall(
        "POST",
        "clinicient/pt/send-patient-email",
        {
            patient: patient?.id,
            email: email?.id,
            html: html,
            subject: subject,
            to: patient?.email || null,
            receipient: patient?.email || null,
            // to: "arnegolemar@gmail.com" || null,
            // receipient: "arnegolemar@gmail.com" || null,
            eventID: eventID,
            emailTemplate: emailTemplate,
            sender: sender
        },
        localStorage.getItem("access-token"),
    );

    if (res?.data?.success) {
        const newPatientList = list?.filter((p, i) => {
            return p.id != patient?.id;
        })

        dispatch({
            type: SET_PATIENTS,
            data: {
                list: [...newPatientList],
                count: count - 1
            }
        })
    }

    return res?.data?.success || false;
}

export const UpdatePatientDisplayType = (patient, displayType = -1) => async (dispatch, getState) => {

    const res = await servicesAPICall(
        "POST",
        "clinicient/pt/update-patient-display-type",
        {
            patient: patient,
            displayType: displayType,
        },
        localStorage.getItem("access-token"),
    );

    if (res?.data?.status == 200) {
        const { list, count } = getState().PatientInvite?.patients;
        let temp = [...list];

        temp = temp.filter(p => p.id != patient);

        dispatch({
            type: SET_PATIENTS,
            data: {
                list: temp,
                count: count - 1
            }
        })

        return true;
    } else {
        return false;
    }
}

export const UpdateDPList = (list = null, count = 0) => (dispatch, getState) => {
    const { patients } = getState().PatientInvite;

    dispatch({
        type: SET_PATIENTS,
        data: {
            list: list,
            count: patients?.count
        }
    })
}

export const UpdatePIList = (list = null, count = 0) => (dispatch, getState) => {
    const { patientInviteLogs } = getState().PatientInvite;

    dispatch({
        type: SET_PATIENT_INVITE_LOGS,
        data: {
            list: list,
            count: patientInviteLogs?.count
        }
    })
}